import React from 'react';
import { Box, Tooltip } from '@mui/material';
import {
    MainContainer,
    ChatContainer,
    MessageList,
    MessageInput,
    Message
} from '@chatscope/chat-ui-kit-react';
import '@chatscope/chat-ui-kit-styles/dist/default/styles.min.css';

// MessageBubble component
function MessageBubble({ message }) {
    return (
      <Tooltip title={message.original || ''}>
        <div style={{ width: '600px' }}>
          <Message
            model={{
              message: message.content,
              sentTime: 'just now',
              sender: 'User',
              direction: message.direction,
            }}
          />
        </div>
      </Tooltip>
    );
  }

function ChatBox({
    messages,
    onSend,
    remainingChats,
    orgPackage,
}) {
    return (
        <Box sx={{ height: '90vh', width: '45vw' }}>
            <MainContainer>
                <ChatContainer sx={{ fontFamily: 'Lato' }}>
                    <MessageList>
                        {messages.map((message, index) => (
                            <MessageBubble message={message} key={index} />
                        ))}
                    </MessageList>
                    <MessageInput
                        placeholder="Type a message..."
                        onSend={
                            remainingChats > 0
                                ? onSend
                                : () =>
                                        alert(
                                            "You've reached your daily max of 4 chats. Your chat allocation will be reset after 24 hours."
                                        )
                        }
                        attachButton={false}
                    />
                </ChatContainer>
            </MainContainer>
            {orgPackage === 'Free' && (
                <Box sx={{ mt: 2 }}>
                    <strong>
                        Chats Remaining:{' '}
                        <span
                            style={{
                                color: remainingChats === 0 ? 'red' : 'inherit',
                            }}
                        >
                            {remainingChats}
                        </span>
                    </strong>
                </Box>
            )}

            <br />
            <b>Disclaimer:</b> AI is experimental and may not always provide accurate answers. Please check the source documents for the most accurate information.
        </Box>
    );
}

export default ChatBox;